/**
 * Extract a user-facing message from API error payloads.
 * Supports Laravel validation errors, billing failures, and network errors.
 */
export function getApiErrorMessage(data, fallback = "Something went wrong. Please try again.") {
  if (!data || typeof data !== "object") {
    return fallback;
  }

  if (typeof data.error === "string" && data.error.trim()) {
    return data.error;
  }

  if (typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (data.error && typeof data.error === "object") {
    if (typeof data.error.error_message === "string" && data.error.error_message.trim()) {
      return data.error.error_message;
    }
  }

  if (data.errors && typeof data.errors === "object") {
    const firstKey = Object.keys(data.errors)[0];
    const first = firstKey ? data.errors[firstKey] : null;

    if (Array.isArray(first) && first[0]) {
      return String(first[0]);
    }

    if (typeof first === "string" && first.trim()) {
      return first;
    }
  }

  return fallback;
}
